import { Text, View, Page, Document, StyleSheet, } from '@react-pdf/renderer';
import { productsDataStyles } from './productsDataStyles';
import { useFormatNumber } from '../../../../hooks/useFormatNumber';
import { defaultTheme } from '../../../../theme/theme';
const { productsData } = productsDataStyles();

export const ProductsData = ({ data, showTranslatedText }: any) => {

    let primaryColor = defaultTheme.palette.primary.main

    const renderHeader = () => (
        <View style={productsData.titleRow} fixed>
            <View style={{ flex: 1, justifyContent: 'center', backgroundColor: primaryColor }}>
                <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.keyProductService")}</Text>
            </View>
            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', backgroundColor: primaryColor }}>
                <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.identificationNo")}</Text>
            </View>
            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', backgroundColor: primaryColor }}>
                <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.quantity")}</Text>
            </View>
            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', backgroundColor: primaryColor }}>
                <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.unitKey")}</Text>
            </View>
            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', backgroundColor: primaryColor }}>
                <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.unitValue")}</Text>
            </View>
            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', backgroundColor: primaryColor }}>
                <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.amount")}</Text>
            </View>
            <View style={{ flex: 1, borderLeftWidth: 1, justifyContent: 'center', backgroundColor: primaryColor }}>
                <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.discount")}</Text>
            </View>
        </View>
    );

    const { setFormatNumber } = useFormatNumber();
    return (
        <View>
            {renderHeader()}
            <View>
                {data.invoiceDetails.length > 0 &&
                    data.invoiceDetails.map((item: any, index: number) =>
                        <View key={index} wrap={false}>
                            <View style={productsData.row} >
                                <View style={{ flex: 1, borderLeftWidth: 1 }}>
                                    <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.item_code || ' '} </Text>
                                </View>
                                <View style={{ flex: 1, borderLeftWidth: 1 }}>
                                    <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.item_id || ' '}</Text>
                                </View>
                                <View style={{ flex: 1, borderLeftWidth: 1 }}>
                                    <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.quantity || ' '}</Text>
                                </View>
                                <View style={{ flex: 1, borderLeftWidth: 1 }}>
                                    <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.unit_code || ' '}</Text>
                                </View>
                                <View style={{ flex: 1, borderLeftWidth: 1 }}>
                                    <Text style={{ textAlign: 'center', fontSize: 6 }}>{setFormatNumber({ value: item.price_by_unit || 0 }) || ' '}</Text>
                                </View>
                                <View style={{ flex: 1, borderLeftWidth: 1 }}>
                                    <Text style={{ textAlign: 'center', fontSize: 6 }}>{setFormatNumber({ value: item.subtotal_amount || 0 }) || ' '}</Text>
                                </View>
                                <View style={{ flex: 1, borderLeftWidth: 1, borderRightWidth: 1 }}>
                                    <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.discount || ' '}</Text>
                                </View>
                            </View>
                            <View style={{ minHeight: 50, flexDirection: 'row', borderLeftWidth: 1, borderBottomWidth: 1, borderRightWidth: 1 }}>
                                <View style={{ flex: 4, flexDirection: 'row', borderRightWidth: 1, borderColor: 'black', }}>
                                    <View style={{ flex: 1, borderRightWidth: 1, justifyContent: 'center' }}>
                                        <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold', }}>
                                            {showTranslatedText("reports.salesInvoicePdf.productsData.description")}
                                        </Text>
                                    </View>
                                    <View style={{ flex: 3, justifyContent: 'center', paddingLeft: 2 }}>
                                        <Text style={{ fontSize: 6, textTransform: 'uppercase' }}>
                                            {item.item_description || ' '}
                                        </Text>
                                    </View>
                                </View>
                                <View style={{ flex: 3, justifyContent: 'center', height: '100%' }}>
                                    <View style={{ flexDirection: 'row', paddingBottom: 2, paddingHorizontal: 3 }}>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.tax")}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.base")}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.quota")}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6, fontWeight: 'bold' }}>{showTranslatedText("reports.salesInvoicePdf.productsData.amount")}</Text>
                                        </View>
                                    </View>
                                    <View style={{ flexDirection: 'row', paddingHorizontal: 3 }}>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.tax_name}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{setFormatNumber({ value: item.subtotal_amount || 0 }) || ' '}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.tax_percent ? `${item.tax_percent}%` : ' '}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.subtotal_tax_amount}</Text>
                                        </View>
                                    </View>
                                    <View style={{ flexDirection: 'row', paddingHorizontal: 3 }}>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.retention_name}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{setFormatNumber({ value: item.subtotal_amount || 0 }) || ' '}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.retention_percent ? `${item.retention_percent}%` : ' '}</Text>
                                        </View>
                                        <View style={{ flex: 1 }}>
                                            <Text style={{ textAlign: 'center', fontSize: 6 }}>{item.subtotal_tax_amount}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>)
                }
            </View>
        </View>
    );
};



